<div class="d-flex justify-content-center">
	<img src="/assets/no-data.jpg" alt="" style="width:50%; height:40%" />
</div>
